
import {
  hotelComparableValueForFilter,
  originalPriceSymbol,
  destinationDisplaySymbol
} from '@/helpers/currencyDisplay'

export default {
  props: {
    collapsible: {
      type: Boolean,
      default: false
    },
    horizontal: {
      type: Boolean,
      default: false
    },
    activeFilterCount: {
      type: Number,
      default: 0
    },
    expanded: {
      type: Boolean,
      default: false
    },
    headless: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      showMaxOptions: 5,
      isOpen: this.expanded || false,
      submitted: false,
      isOptionsCollapsed: true,
      filtersChanged: false,
      selectedTotalPrice: 0,
      rejectedOptions: []
    }
  },
  computed: {
    results () {
      const results = this.$store.state.searchResults
      if (!results.length) return []
      return results
    },
    searchFilters () {
      return this.$store.state.searchHotelsCheckboxes
    },
    filters () {
      const state = this.$store.state
      const converted = this.results.map((r) => hotelComparableValueForFilter(r, state))
      const minTotalPrice = Math.min(...converted)
      const maxTotalPrice = Math.max(...converted)

      return {
        minTotalPrice,
        maxTotalPrice
      }
    },
    allowFilter () {
      return (
        this.selectedTotalPrice !== this.filters.maxTotalPrice ||
        this.filtersChanged
      )
    },
    hotelPriceDisplayMode () {
      return this.$store.state.hotelPriceDisplayMode
    },
    maxPriceFilterLabel () {
      return this.hotelPriceDisplayMode === 'nightly'
        ? this.$t('search.filterOptions.nightlyRate')
        : this.$t('search.filterOptions.totalPrice')
    },
    filtersSymbol () {
      if (!this.results.length) return ''
      const state = this.$store.state
      if (!state.currenciesLoaded) {
        return originalPriceSymbol(this.results[0])
      }
      return destinationDisplaySymbol(state)
    }
  },
  watch: {
    filters: {
      deep: true,
      handler: 'selectDefaults'
    }
  },
  methods: {
    handleHeaderClick () {
      if (this.collapsible) {
        this.isOpen = !this.isOpen
        this.$emit('toggle', this.isOpen)
      } else {
        this.isOpen = !this.isOpen
        this.$emit('toggle', this.isOpen)
      }
    },
    formatPrice (price) {
      if (typeof price !== 'number') {
        return price
      }
      return `${this.filtersSymbol}${Math.round(price)}`
    },
    scrollTo (id) {
      const el = document.getElementById(id)
      if (el) el.scrollIntoView({ behavior: 'smooth' })
    },
    submit () {
      if (!this.allowFilter) return

      this.submitted = true

      setTimeout(() => {
        this.scrollTo('hotel-results')
      }, 500)

      this.$store.commit('setSearchHotelsFilters', {
        rejectedOptions: this.rejectedOptions,
        totalPrice: this.selectedTotalPrice
      })

      this.$emit('applied')
    },
    selectDefaults () {
      this.selectedTotalPrice = this.filters.maxTotalPrice
      this.rejectedOptions = this.rejectedOptions.slice()
    },
    clearFilters () {
      this.submitted = false
      this.$store.commit('clearSearchHotelsFilters')
      this.selectDefaults()
      if (!this.searchFilters) return
      Object.keys(this.searchFilters).forEach((filterKey) => {
        this.optionsSelectAll(filterKey)
      })
    },
    priceModeSegmentClass (mode) {
      const active = this.hotelPriceDisplayMode === mode
      return active
        ? 'bg-[#003580] text-white shadow-sm'
        : 'text-slate-500 hover:bg-white/60 hover:text-slate-800'
    },
    onPriceDisplayModeChange (mode) {
      if (this.hotelPriceDisplayMode === mode) return
      this.$store.commit('setHotelPriceDisplayMode', mode)
      this.$nextTick(() => {
        this.selectedTotalPrice = this.filters.maxTotalPrice
        this.$store.commit('setSearchHotelsFilters', {
          rejectedOptions: this.rejectedOptions,
          totalPrice: this.selectedTotalPrice
        })
      })
    },
    toggleOption (category, e) {
      const code = e.target.value
      if (e.target.checked) {
        const index = this.rejectedOptions.indexOf(code)
        if (index !== -1) this.rejectedOptions.splice(index, 1)
      } else {
        this.rejectedOptions = [...this.rejectedOptions, code]
      }
      const checked = e.target.checked
      this.setSearchHotelsOptionsChecked(category, code, checked)
      this.filtersChanged = true
    },
    setSearchHotelsOptionsChecked (category, code, checked) {
      this.filtersChanged = true
      this.$store.commit('setSearchHotelsOptionsChecked', {
        category,
        code,
        checked
      })
    },
    optionsSelectAll (filterKey) {
      this.rejectedOptions = []
      const keys = Object.keys(this.searchFilters[filterKey].options)

      keys.forEach((option) => {
        this.setSearchHotelsOptionsChecked(filterKey, option, true)
      })

      const checkboxes = keys.map(key => this.$refs[key])

      if (Array.isArray(checkboxes)) {
        checkboxes.forEach((checkbox) => {
          checkbox[0].checked = true
        })
      } else {
        checkboxes.checked = true
      }
    },
    optionsClearAll (filterKey) {
      const keys = Object.keys(this.searchFilters[filterKey].options)
      this.rejectedOptions = keys

      keys.forEach((option) => {
        this.setSearchHotelsOptionsChecked(filterKey, option, false)
      })
      this.$store.commit('setClearAllOptionsEnabled', true)

      const checkboxes = keys.map(key => this.$refs[key])

      if (Array.isArray(checkboxes)) {
        checkboxes.forEach((checkbox) => {
          checkbox[0].checked = false
        })
      } else {
        checkboxes.checked = false
      }
    }
  }
}
